module.exports = __webpack_public_path__ + "img/medal_chocolate.77cf0c6d.svg";